import { useCallback } from "react"
import type { ClipboardEvent } from "react"
import { useChatStore } from "@mui/x-chat-headless"
import { nameClipboardFiles, selectPastedFiles } from "./paste-attachments"
import { useAcceptAttachments } from "./use-accept-attachments"

export function usePasteAttachments(onPaste?: (event: ClipboardEvent<HTMLTextAreaElement>) => void) {
  const store = useChatStore()
  const acceptAttachments = useAcceptAttachments()

  return useCallback((event: ClipboardEvent<HTMLTextAreaElement>) => {
    onPaste?.(event)
    if (event.defaultPrevented) return
    const files = selectPastedFiles(event.clipboardData)
    if (files.length === 0) return
    event.preventDefault()
    const queuedNames = store.state.composerAttachments.map((draft) => draft.file.name)
    acceptAttachments(nameClipboardFiles(files, queuedNames, new Date()), "paste")
  }, [onPaste, store, acceptAttachments])
}
